module.exports = __webpack_public_path__ + "static/media/4.a3eab054.jpg";